const SectionPricing = Class(
	/**
	 * @lends {SectionPricing#}
	 */
	{
		bodyClass: 'small-nav full-container',
		menuItem: 'pricing',

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'pricing',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							this._left = mkE({
								tag: 'div',
								className: 'pricing-left'
							}),
							this._right = mkE({
								tag: 'div',
								className: 'pricing-right'
							})
						]
					}
				]
			});
		},

		route: function(){
			if( !D.PRICE.price ){
				Section.navigate(D.url('/'), {
					popState: true
				});
				return;
			}
		},

		draw: function() {
			this.node.append(this.layout.ct());
			mkE({
				tag: 'div',
				className: 'pricing-change',
				els: [
					{
						tag: 'h1',
						text: D.Lang.get('pricing.change.title')
					},
					{
						tag: 'div',
						className: 'caption',
						text: D.Lang.get('pricing.change.caption')
					},
					new SectionPricing.Timer(),
					{
						tag: 'p',
						text: D.Lang.get('pricing.change.description')
					}
				]
			}).append(this._left);

			let ticketInfo = [];
			for( let i = 0; i < 4; i++ ){
				ticketInfo.push({
					tag: 'li',
					text: D.Lang.get('home.tickets.info.' + i)
				});
			}

			mkE({
				tag: 'div',
				className: 'pricing-ticket',
				els: [
					{
						tag: 'div',
						className: 'pricing-ticket-content',
						els: [
							{
								tag: 'h1',
								text: D.Lang.get('pricing.ticket.title')
							},
							{
								tag: 'h2',
								text: '€' + (D.PRICE.price / 100).toFixed(2)
							},
							{
								tag: 'ul',
								els: ticketInfo
							}
						]
					},
					{
						tag: 'a',
						href: D.url(D.ID ? '/profile' : '/sign-in'),
						className: 'button button-large button-pink button-block',
						text: D.Lang.get('pricing.ticket.get')
					}
				]
			}).append(this._right);
			this.ready();
		},
	},
	Section
);

SectionPricing.Timer = Class(
	/**
	 * @lends {SectionPricing.Timer#}
	 */
	{
		__NAME: 'SectionPricing.Timer',

		__construct: function(){
			this.node = mkE({
				tag: 'div',
				className: 'pricing-timer',
				els: [
					this._content = mkE({
						tag: 'div',
						className: 'pricing-timer-content'
					})
				]
			});
			this._updateTimer();
		},

		_updateTimer: function(){
			let seconds = Math.max(0, 1557176400 - D.TIME);
			if( seconds < 0 ){
				D.reload();
				return;
			}
			let days = Math.floor(seconds / 86400);
			let hours = Math.floor((seconds % 86400) / 3600);
			let minutes = Math.floor(((seconds % 86400) % 3600) / 60);

			let items = [];
			items.push(mkE({
				tag: 'div',
				className: 'pricing-timer-item',
				els: [
					{
						tag: 'div',
						className: 'pricing-timer-value',
						text: str_pad(days, 2, '0', 'STR_PAD_LEFT')
					},
					{
						tag: 'div',
						className: 'pricing-timer-caption',
						text: D.Lang.nget(days, 'pricing.timer.days')
					}
				]
			}));
			items.push(mkE({
				tag: 'div',
				className: 'pricing-timer-divider',
				text: ':'
			}));
			items.push(mkE({
				tag: 'div',
				className: 'pricing-timer-item',
				els: [
					{
						tag: 'div',
						className: 'pricing-timer-value',
						text: str_pad(hours, 2, '0', 'STR_PAD_LEFT')
					},
					{
						tag: 'div',
						className: 'pricing-timer-caption',
						text: D.Lang.nget(hours, 'pricing.timer.hours')
					}
				]
			}));
			items.push(mkE({
				tag: 'div',
				className: 'pricing-timer-divider',
				text: ':'
			}));
			items.push(mkE({
				tag: 'div',
				className: 'pricing-timer-item',
				els: [
					{
						tag: 'div',
						className: 'pricing-timer-value',
						text: str_pad(minutes, 2, '0', 'STR_PAD_LEFT')
					},
					{
						tag: 'div',
						className: 'pricing-timer-caption',
						text: D.Lang.nget(minutes, 'pricing.timer.minutes')
					}
				]
			}));
			clearNode(this._content);
			mkE.appendTypeElement(this._content, items);
			setTimeout(this._updateTimer, 1000);
		}
	},
	mkE.Base
);
